// eslint-disable-next-line import/prefer-default-export
export const selectOrgPackage = (orgId) => (state) => state.entities.orgs.byId[orgId]?.package;
